import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from 'api';
import { addArgsToPath, defaultTransformResponse } from 'common/helpers/v1';


const TAGS = [] as string[];

export const dsiApi = createApi({
  reducerPath: 'dsiApi', //Key in the Redux store where the API slice's reducer state will be stored//prevents conflicts with other slices or reducers
  baseQuery: baseQueryWithReauth, // Replace '/api' with your actual base URL
  tagTypes: TAGS, //Tags are used to group endpoints together in the generated hooks
  endpoints: (builder) => ({
    getMachineStatus: builder.query({
      query: ({ machineId, ...rest }) => {
        return `/mh/v1/dsi/machines/${machineId ?? ''}/connection-info`;
      },
      transformResponse: defaultTransformResponse
    }),
    getSummerPSUData: builder.query({
      query: (args) => {
        const { machineId, ...rest } = args;
        return `/mh/v2/dsi/machine-health/${machineId ?? ''}/summed-psu-data${addArgsToPath(rest)}`;
      },
      transformResponse: defaultTransformResponse
    }),
    getMachineStates: builder.query<
          {
            recipe?: number;
            recipe_descr?: string;
            mode_number?: number;
            mode_descr?: string;
            run_login_id?: string;
            start_time?: string;
            end_time?: string;
          }[],
          {
            machineId: string;
            utc_start_datetime?: string;
            utc_end_datetime?: string;
            aggregate_by?: string[];
          }
        >({
          query: (args: {
            machineId: string;
            utc_start_datetime?: string;
            utc_end_datetime?: string;
            aggregate_by?: string[];
          }) => {
            const { machineId, ...rest } = args;
            let path = `/mh/v1/dsi/machine-health/${machineId}/machine-states`;
            path = path + addArgsToPath(rest);
            return path;
          },
          transformResponse: defaultTransformResponse
        }),
  })
});

export const {
  useGetMachineStatusQuery,
  useGetSummerPSUDataQuery,
  useGetMachineStatesQuery
} = dsiApi;
